import { render, staticRenderFns } from "./GenerateProfileEmployee.vue?vue&type=template&id=dc13afd4&scoped=true&"
import script from "./GenerateProfileEmployee.vue?vue&type=script&lang=js&"
export * from "./GenerateProfileEmployee.vue?vue&type=script&lang=js&"
import style0 from "./GenerateProfileEmployee.vue?vue&type=style&index=0&id=dc13afd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13afd4",
  null
  
)

export default component.exports